import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 Planning every step class from scratch', '🔁 Repeating the same 5 patterns every week', '🌙 Spending your evenings building sequences', '💭 Running out of choreography ideas', '😰 Freezing when a student has knee pain', '📉 No class progression — students lose interest'];
const withItems = ['📖 Open the drill bank', '🎯 Choose today’s sequence', '💪 Teach with real professional confidence', '♾️ 50+ drills — always something new', '📅 A full year already structured for you', '🏆 Every client progressing every week'];
function Panel({
  title,
  label,
  items,
  positive
}: {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
}) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-mint' : 'bg-surface'}`} data-id="element-31" data-mp="28um85rky6umv">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-green-dark' : 'text-red-500'}`} data-id="element-32" data-mp="9lfgrp1hpupq">
        {label}
      </p>
      <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-33" data-mp="1m0gzmk8qyc4c">{title}</h3>
      <ul className="mt-7 divide-y divide-ink/10" data-id="element-34" data-mp="1h9h2bdvpts1b">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-35" data-mp="1d8f2autz5bya">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-36" data-mp="24zbdzs4atajz">
      <div className="mx-auto max-w-6xl" data-id="element-37" data-mp="24ys510wmlwi3">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-38" data-mp="20xge8s20n58b">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl" data-id="element-39" data-mp="20vvi4y01ze8c">
            The Difference a <span className="text-green-dark" data-id="element-40" data-mp="1qzsipzwl5tp3">Real System</span> Makes
          </h2>
          <p className="mt-5 text-slate" data-id="element-41" data-mp="1r1wj47va0akm">You’re not buying files. You’re buying a complete teaching operating system.</p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-42" data-mp="fk3tf1vv0il4">
          <div className="mt-10 overflow-hidden rounded-2xl border border-ink/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-43" data-mp="fjvjniv19te5">
            <Panel label="❌ WITHOUT" title="Without Step Class Ready™" items={withoutItems} data-id="element-44" data-mp="gzpreo24w00y" />
            <Panel positive label="✅ WITH" title="With Step Class Ready™" items={withItems} data-id="element-45" data-mp="m04088bk7e01" />
          </div>
        </Reveal>
      </div>
    </section>;
}